"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgTableCertified14pxSmall = void 0;
var React = require("react");
function SvgTableCertified14pxSmall(props) {
    return (React.createElement("svg", __assign({ width: 14, height: 14 }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#BFBFBF", d: "M5 4v2h2v1H5v2h1v1H5v2H4v-2H1V9h3V7H1V6h3V4h1zm4 0v2H8V4h1z" }),
            React.createElement("path", { fill: "#666", d: "M12 0a1 1 0 0 1 1 1v5h-1V4H1v8h5v1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h11zm0 1H1v2h11V1z" }),
            React.createElement("circle", { cx: 10.5, cy: 10.5, r: 3.5, fill: "#008057" }),
            React.createElement("path", { fill: "#FFF", d: "M11.787 8.54l.794.437-1.98 3.608a.45.45 0 0 1-.132.147l-.073.042-.016.007a.455.455 0 0 1-.507-.083l-1.645-1.554.631-.647 1.226 1.153 1.702-3.11z" }))));
}
exports.SvgTableCertified14pxSmall = SvgTableCertified14pxSmall;
//# sourceMappingURL=TableCertified14pxSmall.js.map